import { Typography, TypographyProps } from '@mui/material';

export const TypographyOverflow = ({ children, sx, ...props }: TypographyProps) => {
	return (
		<Typography
			component="div"
			{...props}
			sx={{
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				minWidth: 0,
				...sx,
			}}>
			{children}
		</Typography>
	);
};
